<script>
  export default {
    props: ["user", "policy"],
    components: {
      MenuFilterByCityHq: () => import("./MenuFilterByCityHq.vue"),
      PolicyAccessCrmReservations: () => import("./PolicyAccessCrmReservations.vue"),
      PolicyAssignRegisterTypes: () => import("./PolicyAssignRegisterTypes.vue"),
      PoliceCities: () => import("@/components/organisms/PoliceCities.vue"),
      ConferencePolice: () => import("@/components/organisms/ConferencePolice.vue"),
    },
    data: function () {
      return {
        myPolicy: {},
        resetValues: 0,
      };
    },
    computed: {
      isPolicyActive: function () {
        const isEnable = this.user.polices && this.user.polices[this.policy.key] && this.user.polices[this.policy.key].status;
        this.$store.state.user.numTest;
        return isEnable ?? false;
      },
      policyValue: function () {
        const value = this.user.polices && this.user.polices[this.policy.key] && this.user.polices[this.policy.key].value;
        this.$store.state.user.numTest;
        return this.convertToType(value, this.policy.valueType);
      },
      changedPoliceValues() {
        const noRequireVerify = !this.policy.hasValue && this.policy.valueType === "Boleean";

        if (noRequireVerify) {
          return true;
        }

        const isEqValue = this.myPolicy?.value !== this.policy?.value;
        const isEqPayload = JSON.stringify(this.myPolicy?.payload).length !== JSON.stringify(this.policy?.payload).length;
        this.$store.state.user.numTest;

        return isEqValue || isEqPayload;
      },
      registerTypesPolicy() {
        return this.policy.relatedPolicies?.registerTypes || null;
      },
      isSeeForm() {
        return this.policy.key === "see-from";
      },
    },
    methods: {
      normalizeRegisterTypes(registers = []) {
        const normalized = registers.map((register) => String(register).trim().toLowerCase()).filter((register) => !!register);

        const unique = normalized.filter((register, index, array) => array.indexOf(register) === index);

        if (unique.includes("both")) {
          return unique;
        }

        const limitedValues = ["free", "private"];
        return limitedValues.filter((register) => unique.includes(register));
      },
      changeValue({ politic, target }) {
        let hasValue = true;

        if (target) {
          this.myPolicy["value"] = this.convertToType(target.value, this.policy.valueType);
          hasValue = !!target?.value;
        } else {
          const { allOptionsSeleted, allowedRegisters } = politic || {};
          const payload = allOptionsSeleted !== undefined ? allOptionsSeleted : allowedRegisters !== undefined ? allowedRegisters : politic;

          if (Array.isArray(payload)) {
            const normalizedPayload = this.normalizeRegisterTypes(payload);
            hasValue = normalizedPayload.length;
            this.myPolicy["payload"] = [...normalizedPayload];
            this.myPolicy["value"] = [...normalizedPayload];
          } else if (payload && typeof payload === "object") {
            hasValue = Object.keys(payload).length;
            this.myPolicy["payload"] = { ...payload };
            if (Array.isArray(payload?.allowedRegisters)) {
              const normalizedPayload = this.normalizeRegisterTypes(payload.allowedRegisters);
              hasValue = normalizedPayload.length;
              this.myPolicy["value"] = [...normalizedPayload];
            }
          } else {
            hasValue = !!payload;
            this.myPolicy["payload"] = payload;
            this.myPolicy["value"] = payload;
          }
        }

        if (!hasValue) {
          this.myPolicy["status"] = false;
          this.$emit("change", { policy: this.myPolicy });
          this.resetValues++;
          return;
        }

        this.myPolicy["status"] = true;
        this.$emit("change", { policy: this.myPolicy });
      },
      changeRelatedPolicy({ politic }) {
        if (!this.registerTypesPolicy) {
          return;
        }

        const policyClone = {
          ...this.registerTypesPolicy,
        };
        const payloadSource = politic?.allowedRegisters ?? politic;
        const normalizedPayload = this.normalizeRegisterTypes(payloadSource);
        const hasValue = normalizedPayload.length > 0;

        policyClone.payload = [...normalizedPayload];
        policyClone.value = [...normalizedPayload];
        policyClone.status = hasValue;

        if (!hasValue) {
          this.$emit("change", { policy: policyClone });
          this.resetValues++;
          return;
        }

        this.$emit("change", { policy: policyClone });
      },
      handleModuleToggle(checked) {
        this.myPolicy["status"] = checked;
        if (!checked) {
          this.resetValues++;
        }
        this.$emit("change", { policy: this.myPolicy });
      },
      changeToggle({ target }) {
        const checked = target.checked;

        if (checked && !this.changedPoliceValues) {
          target.checked = false;
          return;
        }
        if (!checked) {
          this.resetValues++;
        }

        this.myPolicy["status"] = checked;
        this.$emit("change", { policy: this.myPolicy });
      },
    },
    mounted: function () {
      if (!this.policy?.value) {
        this.policy.value = "";
      }
      if (!this.policy?.payload) {
        this.policy.payload = {};
      }
      this.myPolicy = structuredClone(this.policy);
    },
  };
</script>

<template>
  <div :class="`user-policy`">
    <div class="user-policy-left" :key="resetValues">
      <p class="user-policy__title" v-if="isSeeForm">Aplicacion Registro</p>

      <div :class="`user-policy-desc policy-${user._id}-${policy.key}`">
        <span v-if="!['see-models-register', 'see-monitors-conference', 'see-models'].includes(policy.key)">{{ policy.label }}</span>
        <input :type="policy.valueType" class="user-policy__input" placeholder="Ingresar valor" v-if="policy.hasValue" @change="changeValue" role="hasValue" :value="policyValue" ref="input" />
        <MenuFilterByCityHq v-if="policy.key === 'see-models'" ref="MenuFilterByCityHq" :policy="policy" :user="user" @result-updated="changeValue" @toggle-status="handleModuleToggle" />
        <PolicyAccessCrmReservations v-if="policy.key === 'Access-reservations-CMS-fields'" ref="AccessAdministration" :policy="policy" :user="user" @result-updated="changeValue" />

        <div v-if="registerTypesPolicy" class="user-policy-related">
          <span class="user-policy-related__label">{{ registerTypesPolicy.label }}:</span>
          <PolicyAssignRegisterTypes ref="PolicyAssignRegisterTypes" :policy="registerTypesPolicy" :user="user" @result-updated="changeRelatedPolicy" />
        </div>
      </div>
    </div>
    <PoliceCities
      v-if="policy.key === 'see-models-register' && ['coordinator', 'monitor', 'employee'].includes(user.role)"
      ref="PoliceCities"
      :policy="policy"
      :user="user"
      @result-updated="changeValue" />
    <ConferencePolice
      v-if="policy.key === 'see-monitors-conference' && ['coordinator', 'monitor', 'employee'].includes(user.role)"
      ref="ConferencePolice"
      :policy="policy"
      :user="user"
      @result-updated="changeValue" />
    <div class="user-policy-right" v-if="!['see-models-register', 'see-monitors-conference', 'see-models'].includes(policy.key)" :style="{ marginTop: isSeeForm ? '37px' : '' }">
      <ToggleSwitch :class="`policy-${user._id}-${policy.key}`" @change="changeToggle" ref="toggle" :checked="isPolicyActive" />
    </div>
  </div>
</template>

<style lang="scss">
  .user-policy {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-top: solid 1px $alto;
    padding: $mpadding;

    &__title {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 14px;
      .user-policy-right {
        margin-top: 100px;
      }
    }

    &__input {
      border: none;
      border-bottom: solid 1px $alto;
      padding: $mpadding/2 0;
      font-weight: bold;
    }
    &-related {
      @include Flex(row, flex-start, flex-start);
      margin-top: 14px;
      gap: 10px;

      &__label {
        font-size: 16px;
      }
    }
  }
</style>
